import(/* webpackMode: "eager" */ "C:\\dev\\cfs-website\\next\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "C:\\dev\\cfs-website\\next\\node_modules\\next\\dist\\client\\image-component.js");
